export default function Spotrecs(props) {
  window.location.href = "https://github.com/jyu/spotrecs";
  return null;
}
